import * as React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import Slide from '@mui/material/Slide';
import { TransitionProps } from '@mui/material/transitions';
import { DialogActions, DialogTitle, Divider, Stack, Typography } from '@mui/material';
import { useAppSelector } from '../hooks/useRedux';
import useConfirm from '../hooks/useConfirm';
import Button from './Button/Button';

const Transition = React.forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement<any, any>;
  },
  ref: React.Ref<unknown>
) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const ConfirmDialog = () => {
  const { onCancel, onConfirm } = useConfirm();
  const open = useAppSelector((state) => state.confirm.open);
  const dialogSettings = useAppSelector((state) => state.confirm.dialogState);

  return (
    <Dialog
      open={open}
      TransitionComponent={Transition}
      keepMounted
      onClose={onCancel}
      aria-describedby="confim-dialog"
      sx={{ zIndex: 99 }}
    >
      <DialogTitle>{dialogSettings?.title}</DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-slide-description">{dialogSettings?.description}</DialogContentText>
        {dialogSettings?.confirmBody ? dialogSettings.confirmBody : null}
        {dialogSettings?.confirmBody ? <Divider sx={{ mt: 2 }} /> : null}
      </DialogContent>
      <DialogActions>
        {dialogSettings?.cancelButtonText ? (
          <Button onClick={onCancel} variant="outlined">
            {dialogSettings?.cancelButtonText}
          </Button>
        ) : null}
        <Button onClick={onConfirm} variant="contained">
          {dialogSettings?.confirmButtonText}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmDialog;
